import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "../LoadingIndicator";
import "./HawbBulkUpload.scss";
import uploadIconBlack from "../../assets/images/uploadIconBlack.svg";
import downloadIcon from "../../assets/images/downloadIcon.svg";
import closeIcon from "../../assets/images/close-outline.svg";
import getCurrentUser from "../../utils/getCurrentUser";
import { doHawbBulkUpload } from "../../services/dataCaptureService";
import { Dialog } from "primereact/dialog";
import { CustomPopup } from "../../common/Popup/CustomPopup";

const HawbBulkUploadPopup = ({
  handlePopupClose,
  isLoading,
  setIsLoding,
  awbNumber,
  showSuccess,
  getBulkUploadStatus,
  setFailedRecords,
  setBulkUploadStatus,
  setBulkUploadDone,
  failedRecord,
  validationRule,
  hsCodeMandatory,
  hawbNumbers,
  setFailedRecordsCount,
}) => {
  const { t } = useTranslation(["labels", "errors"]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const fileInputRef = useRef(null);

  const isExcelFile = (file) => {
    const validExtensions = [".xlsx", ".xls"];
    const filePath = file.name?.toLowerCase();
    return validExtensions.some((ext) => filePath.endsWith(ext));
  };

  const uploadFile = async (file) => {
    if (file) {
      setFailedRecords(null);
      setBulkUploadStatus(null);
      setFailedRecordsCount(0);
      const currentUser = getCurrentUser();
      if (currentUser) {
        var formData = new FormData();

        formData.append("userId", currentUser.userId);
        formData.append("agentCode", currentUser.agentCode);
        formData.append("fileName", file.name);
        formData.append("emailId", currentUser.email);
        formData.append("firstName", currentUser.firstName);
        formData.append("hawbBulkUploadExcel", file);
        formData.append("awbNo", awbNumber);
        formData.append("hscodeEnabled", hsCodeMandatory);
        if (validationRule && validationRule.length > 0) {
          formData.append("hawbValidationRules", JSON.stringify(validationRule[0]));
        }
        formData.append("hawbNumbers", hawbNumbers);
        try {
          setIsLoding(true);
          setBulkUploadDone(true);
          const response = await doHawbBulkUpload(formData);
          if (response?.status === "success") {
            setIsLoding(false);
            showSuccess();
            handlePopupClose();
            getBulkUploadStatus(awbNumber);
          } else {
            setError("Excel Upload Failed");
          }
        } catch (error) {
          setError(error.message);
        }
      }
    }
    setIsLoding(false);
  };

  const setFileToState = (files) => {
    setError("");
    if (files && files[0]) {
      if (isExcelFile(files[0])) {
        setSelectedFile(files[0]);
      } else {
        setError("Please choose an Excel file (xlsx/xls)");
        setSelectedFile(null);
      }
    }
  };

  const onUploadLabelClick = (e) => {
  e.stopPropagation(); // Prevent bubbling
  if (fileInputRef.current) {
    fileInputRef.current.value = ""; 
    fileInputRef.current.click();
  }
};

  const onUploadButtonClick = () => {
    if (!error)
      if (failedRecord) {
        setShowConfirmationDialog(true);
      } else {
        uploadFile();
      }
  };

  const handleFileChange = (e) => {
  const { files } = e.target;
  setError("");
  if (files && files[0]) {
    const file = files[0];
    if (isExcelFile(file)) {
      setSelectedFile(file);
      if (failedRecord) {
        setShowConfirmationDialog(true);
      } else {
        uploadFile(file); // use the file directly
      }
    } else {
      setError("Please choose an Excel file (xlsx/xls)");
      setSelectedFile(null);
    }
  }
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

  const handleDrop = (event) => {
  event.preventDefault();
  const { files } = event.dataTransfer;
  setError("");
  if (files && files[0]) {
    const file = files[0];
    if (isExcelFile(file)) {
      setSelectedFile(file);
      if (failedRecord) {
        setShowConfirmationDialog(true);
      } else {
        uploadFileDirect(file); // use the file directly
      }
    } else {
      setError("Please choose an Excel file (xlsx/xls)");
      setSelectedFile(null);
    }
  }
};


  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleYesClick = () => {
    setShowConfirmationDialog(false);
    setFailedRecords(null);
    setBulkUploadStatus(null);
    // uploadFile();
    if (selectedFile) {
    uploadFile(selectedFile);
  }
  };

  const handleNoClick = () => {
    setShowConfirmationDialog(false);
    handlePopupClose();
  };

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = process.env.PUBLIC_URL + "/HAWB_Upload_Template_v1.xlsx";
    link.download = "HAWB_Upload_Template_v1.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onCloseButtonClick = () => {
    setError("");
    setSelectedFile(null);
    handlePopupClose();
  };

  return (
    <>
      {isLoading && <LoadingIndicator />}
      <div className="file-upload-section hawb-bulk-upload-popup">
        <div className="file-input-download my-2">
          <input
            ref={fileInputRef}
            type="file"
            id="hawbBulkFileButton"
            accept=".xlsx,.xls"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <img
            src={uploadIconBlack}
            alt="upload"
            title="upload"
            id="upload-icon"
          />
          <div
            className="upload-drop-label"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            htmlFor="hawbBulkFileButton"
          >
            <label
              className="upload-label"
              style={{ cursor: "pointer" }}
              onClick={onUploadLabelClick}
            >
              {t("CAPTURE_AWB.UPLOAD_CLICK")}
            </label>
            <label className="drop-label">{t("CAPTURE_AWB.UPLOAD_DROP")}</label>
          </div>
          <label className="drop-label">
            {/* {selectedFile ? selectedFile.name : t('CAPTURE_AWB.UPLOAD_DROP')} */}
            {selectedFile ? selectedFile.name : "Excel File (max 2 MB)"}
          </label>
          <span className="search-panel__errormsg m-0">
            {error && error !== "" ? error : ""}
          </span>
        </div>
        <div className="file-input-download my-2">
          <img
            src={downloadIcon}
            alt="download"
            title="download"
            id="download-icon"
          />
          <span
            className="downld_temp"
            style={{ cursor: "pointer" }}
            onClick={handleDownloadTemplate}
          >
          <label className="downld-temp-label"  style={{ cursor: "pointer" }}  onClick={handleDownloadTemplate}>  {t("CAPTURE_HAWB.DOWNLOAD_TMP")} </label>
          </span>
        </div>
        {/* Confirmation Dialog */}
         {showConfirmationDialog && (
         
         <CustomPopup
            footerPriBtnLabel={t('COMMON.YES')}
            footerSecBtnLabel={t('COMMON.NO')}
            className={"hawbpopup-confirmation-popup"}
            footerPriBtnClick={handleYesClick}
            footerSecBtnClick={handleNoClick}
            headerComponent={{ mainHeader: t("COMMON.CONFIRM") }}
            body={<p>
              Outstanding errors exist in the previous record. These errors will
              be discarded on the new Excel Upload. Do you wish to continue?
            </p>}
            onClose={handleNoClick}
            isVisible={showConfirmationDialog}
          />
         
         
        //  <Dialog
        //     visible
        //     modal
        //     closable={false}
        //     header="Confirmation"
        //     style={{ width: "450px" }}
        //     className="hawbpopup-warning-popup"
        //   >
        //     <p className="d-flex justify-content-center mt-1">
        //       Outstanding errors exist in the previous record. These errors will
        //       be discarded on the new Excel Upload. Do you wish to continue?
        //     </p>
        //     <div className="confirmation-dialog-buttons d-flex justify-content-around mt-4">
        //       <button
        //         type="button"
        //         className="button"
        //         onClick={handleYesClick}
        //       >
        //         Yes
        //       </button>
        //       <button
        //         type="button"
        //         className="button secondary"
        //         onClick={handleNoClick}
        //       >
        //         No
        //       </button>
        //     </div>
        //   </Dialog>
        )}

        {/* {showConfirmationDialog && (
          <div className="hawbpopup-warning-popup">
            <div className="hawbpopup-warning-content">
              <p className="d-flex justify-content-center mt-1">
                Outstanding errors exist in the previous record. These errors will
                be discarded on the new Excel Upload. Do you wish to continue?
              </p>
              <div className="confirmation-dialog-buttons d-flex justify-content-around mt-4">
                <button
                  type="button"
                  className="button"
                  onClick={handleYesClick}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="button secondary"
                  onClick={handleNoClick}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default HawbBulkUploadPopup;
